<template>
	<div v-if="list.length" class="finance-bank">
		<div class="section-label">金融机构</div>
		<OptionBox
			:options="list"
			:value="value"
			value-key="bank_id"
			label-key="bank_name"
			@change="selectBank"
		/>
	</div>
</template>

<script>
import OptionBox from '@/components/OptionBox.vue'

export default {
	name: 'FinanceBank',
	components: { OptionBox },
	props: {
		list: { type: Array, default: () => [] },
		value: { type: [String, Number], default: '' }
	},
	methods: {
		selectBank(bankId, bankItem) {
			if (bankId !== this.value) this.$emit('change', bankItem)
		}
	}
}
</script>

<style scoped lang="scss">
@import '~@nio-fe/nio-app-ui/es/style';
.finance-bank {
	margin-top: 40px;
	padding: 0 20px;
}
.section-label {
	margin-bottom: 10px;
	@include subtitle_2(1.5, 500, false);
}
</style>
